const { normalizeLanguage } = require('../i18n/translations');

const REGULATORY_NOTES = {
  en: 'This manifest supports V2 static audit preparation and tamper-evidence checks. It is not a standalone 21 CFR Part 11 validation package.',
  pt: 'Este manifesto apoia a preparação de auditoria estática V2 e verificações de evidência de adulteração. Ele não é um pacote independente de validação 21 CFR Part 11.',
  es: 'Este manifiesto apoya la preparación de auditoría estática V2 y verificaciones de evidencia de alteración. No es un paquete independiente de validación 21 CFR Part 11.'
};

function buildIntegrityManifest(result, signature, auditSnapshot, options = {}) {
  const language = normalizeLanguage(options.language || 'pt');

  return {
    manifestType: 'randFlow integrity manifest',
    manifestVersion: '2.0',
    generatedAt: new Date().toISOString(),
    randFlowVersion: result.version,
    language,
    studyName: result.parameters.studyName || '',
    algorithm: {
      id: result.algorithmId,
      name: result.algorithm,
      seed: result.seed
    },
    normalizedParameters: result.parameters,
    resultIntegrity: {
      experimentSignature: signature,
      sequenceLength: result.sequence.length,
      validation: result.metrics.validation,
      warnings: result.metrics.warnings
    },
    audit: {
      sessionId: auditSnapshot.sessionId,
      eventCount: auditSnapshot.eventCount,
      chainHead: auditSnapshot.chainHead
    },
    regulatoryNote: REGULATORY_NOTES[language]
  };
}

function manifestToJson(result, signature, auditSnapshot, options = {}) {
  return JSON.stringify(buildIntegrityManifest(result, signature, auditSnapshot, options), null, 2);
}

module.exports = {
  buildIntegrityManifest,
  REGULATORY_NOTES,
  manifestToJson
};
